var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"notification_label"},[_vm._v(_vm._s(_vm.notification.data.webhook.label)+" Webhook Failed. Contact Support")]),_vm._v(" "),_c('button-link',{on:{"click":_vm.goToPhoneWebhooksPage}},[_vm._v("Go To Webhooks")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }